import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { usePageSeo } from "../../Hooks/usePageSeo";

const PagePublicSite = (props: any) => {
    const navigation = useNavigate();

    // Tenant pages (login, new member, edit member, ...) are per-customer app screens, not marketing content.
    usePageSeo({ pageTitle: props.pageTitle, noIndex: true });

    const cssClass = "Page PagePublicSite " + props.className;

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default PagePublicSite;
